<template>
  <div>
    <Breadcrumbs title="Add combo" main="Database"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <form @submit.prevent="createCombo">

            <div class="card">
              <div class="card-body">
                <div class="form-group m-form__group">
                  <label>Total price</label>
                  <div role="group" class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <input type="number" placeholder="100.0" class="form-control" v-model="price">
                  </div>
                </div>
              </div>
            </div>

            <div v-for="(record, index) in records" :key="index">

              <div class="card">
                <div class="card-header">
                  <div class="row">
                    <div class="col-md-4">
                      <h5>Product #{{ index }}</h5>
                    </div>
                    <div class="col-md-1 offset-md-7" v-if="index >= 2">
                      <div class="pull-right" @click="removeProductRow(index)"><span class="fa fa-trash text-danger"
                                                                                     style="font-size: 20px;"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="form-group">
                    <label>Date</label>
                    <input type="date" class="form-control" v-model="records[index].date">
                  </div>

                  <div class="form-group autocomplete">
                    <label>Competitor</label>
                    <vue-autosuggest
                        v-model="records[index].competitor"
                        :suggestions="filteredOptions"
                        @selected="onSelected"
                        @focus="onFocus(index)"
                        @input="inputHandler"
                        :get-suggestion-value="getSuggestionValue"
                        :input-props="{id:`autosuggest__input_${index}`, class:'form-control', placeholder:'Easy parts'}">
                      <div slot-scope="{suggestion}" style="display: flex; align-items: center;">
                        <div>{{ suggestion.item }}</div>
                      </div>
                    </vue-autosuggest>
                  </div>

                  <div class="form-group">
                    <label>Part Number</label>
                    <input type="text" class="form-control" placeholder="559123041" v-model="records[index].part_number"
                           @change="getPartInfo">
                  </div>

                  <div class="form-group">
                    <label>Brand</label>
                    <input type="text" class="form-control" placeholder="BMW" v-model="records[index].brand">
                  </div>

                  <div class="form-group">
                    <label>Name</label>
                    <input type="text" class="form-control" placeholder="Led headlight" v-model="records[index].name">
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <div class="btn btn-dark" style="width: 100%" @click="addProductRow">Add product</div>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <router-link
                    to="/research/database"
                    custom
                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                  <a :href="href" @click="navigate" class="btn btn-info mr-2">Cancel</a>
                </router-link>
                <button type="submit" class="btn btn-primary pull-right">Save</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style>

.autosuggest__results ul {
  width: 100%;
  color: rgba(30, 39, 46, 1.0);
  list-style: none;
  margin: 0;
  padding: 0.5rem 0 .5rem 0;
  border: 1px solid black;
  position: absolute;
  background-color: white;
}

.autosuggest__results li {
  margin: 0 0 0 0;
  border-radius: 5px;
  padding: 0.75rem 0 0.75rem 0.75rem;
  display: flex;
  align-items: center;
}

.autosuggest__results li:hover {
  cursor: pointer;
}

.autosuggest__results {
  position: relative;
}

.autosuggest-container {
  display: flex;
  justify-content: center;
  width: 280px;
}

#autosuggest {
  width: 100%;
  display: block;
}

.autosuggest__results-item--highlighted {
  background-color: rgba(51, 217, 178, 0.2);
}
</style>

<script>
import {competitorProduct} from "../../../_services";
import {VueAutosuggest} from 'vue-autosuggest';

export default {
  data: function () {
    return {
      currentCompetitor: "",
      currentCompetitorIndex: null,
      selected: "",
      suggestions: [],
      records: [
        {
          competitor: "",
          date: null,
          part_number: null,
          brand: null,
          name: null,
        },
        {
          competitor: "",
          date: null,
          part_number: null,
          brand: null,
          name: null,
        },
      ],
      price: null
    }
  },
  components: {
    VueAutosuggest
  },
  computed: {
    filteredOptions() {
      return [
        {
          data: this.suggestions.filter(option => {
            return option.toLowerCase().indexOf(this.currentCompetitor.toLowerCase()) > -1;
          })
        }
      ];
    }
  },
  created() {
    this.loadCompetitorList();
  },
  methods: {
    inputHandler(e) {
      this.currentCompetitor = e;
    },
    onFocus(index) {
      if (this.currentCompetitorIndex !== index) {
        this.currentCompetitor = "";
      }
      this.currentCompetitorIndex = index;
    },
    addProductRow() {
      this.records.push(
          {
            competitor: "",
            date: null,
            part_number: null,
            brand: null,
            name: null,
          }
      )
    },
    removeProductRow(index) {
      this.records.splice(this.records.indexOf(index), 1);
    },
    createCombo() {
      competitorProduct.addCompetitorProductCombo(
          this.price,
          this.records
      )
          .then(
              async () => {
                const {dispatch} = this.$store;
                dispatch('alert/success', 'Product combo success added', {root: true});

                this.$router.push({
                  path: '/research/database'
                });
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    },
    getPartInfo() {
      competitorProduct.getPartInfo(
          this.part_number
      )
          .then(
              async response => {
                this.brand = response.data.brand;
                this.name = response.data.name;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    },
    onSelected(item) {
      this.selected = item.item;
      this.records[this.currentCompetitorIndex].competitor = item.item;
    },
    getSuggestionValue(suggestion) {
      return suggestion.item;
    },
    loadCompetitorList() {
      competitorProduct.getCompetitorList()
          .then(
              async response => {
                this.suggestions = response.data.competitors;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    }
  }
}
</script>
